<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.customer.exists_header' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <!-- <div class="row">
        <div class="col-lg-12">
            <div class="customer-message">{{'bikeshop.workshop.jobcard.customer.exists_message' |
                translate}}</div>
        </div>
    </div> -->

    <div class="header">
        {{ 'bikeshop.workshop.jobcard.customer.existing_customer' | translate }}
    </div>
    <div class="customer-details-container">
        <div class="customer-header">
            <div>{{existingCustomer.Name}} {{existingCustomer.Surname}}</div>
        </div>
        <div class="customer-details">
            <div *ngIf="existingCustomer.PhoneNumber">
                <div class="customer-detail">
                    <div><daz-icon [name]="'phone-alt-1'" [size]="'24px'" [color]="'#6D6D6D'"></daz-icon></div>
                    <div>
                        <div>{{'bikeshop.switch_shop.phone_number' | translate }}</div>
                        <div>{{existingCustomer.PhoneNumber}}</div>
                    </div>
                </div>
            </div>
            <div *ngIf="existingCustomer.Email">
                <div class="customer-detail">
                    <div><daz-icon [name]="'mail-alt-1'" [size]="'24px'" [color]="'#6D6D6D'"></daz-icon></div>
                    <div>
                        <div>{{'onboarding.email' | translate }}</div>
                        <div>{{existingCustomer.Email}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="header">
        {{ 'bikeshop.workshop.jobcard.customer.new_customer' | translate }}
    </div>
    <div class="customer-details-container">
        <div class="customer-header">
            <div>{{newCustomer.Name}} {{newCustomer.Surname}}</div>
        </div>
        <div class="customer-details">
            <div>
                <div class="customer-detail" *ngIf="newCustomer.PhoneNumber">
                    <div><daz-icon [name]="'phone-alt-1'" [size]="'24px'" [color]="'#6D6D6D'"></daz-icon></div>
                    <div>
                        <div>{{'bikeshop.switch_shop.phone_number' | translate }}</div>
                        <div>{{newCustomer.PhoneNumber}}</div>
                    </div>
                </div>
            </div>
            <div>
                <div class="customer-detail" *ngIf="newCustomer.Email">
                    <div><daz-icon [name]="'mail-alt-1'" [size]="'24px'" [color]="'#6D6D6D'"></daz-icon></div>
                    <div>
                        <div>{{'onboarding.email' | translate }}</div>
                        <div>{{newCustomer.Email}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <div>
            <hub-button [text]="'general.cancel' | translate" [style]="'outline'" (buttonClick)="cancel()"
                [size]="'xl'"></hub-button>
        </div>
        <div>
            <hub-button [text]="'bikeshop.workshop.jobcard.customer.edit_existing_customer' | translate"
                [style]="'secondary'" (buttonClick)="  editExistingCustomer()" [size]="'xl'"></hub-button>
            <hub-button [text]="'bikeshop.workshop.jobcard.customer.exists_continue_with_existing_customer' | translate"
                [style]="'secondary'" (buttonClick)="selectExistingCustomer()" [size]="'xl'"></hub-button>
        </div>
    </div>
</div>